












































import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import { GQL_order_order } from '@/queries/__generated__/order';
import { GQL_invoice_invoice, GQL_invoice_invoice_invoiceOverdueNotices } from '@/queries/__generated__/invoice';
import { DocumentShowType } from './DocumentHeader.vue';

@Component
export default class DocumentFooter extends Vue {
  @Prop(Object) public document!: GQL_order_order | GQL_invoice_invoice;
  @Inject() public documentType!: 'order' | 'invoice';
  @Inject() public documentShowType!: DocumentShowType;

  // TODO: When we have requirements to support other country invoices, implement this to be read from bankAccounts.
  public bankAccountCountryCode = 'NO';

  get lastOverdueNotice(): GQL_invoice_invoice_invoiceOverdueNotices | null {
    return (this.document as GQL_invoice_invoice).invoiceOverdueNotices[(this.document as GQL_invoice_invoice).invoiceOverdueNotices.length - 1];
  }
}
